import React, {useState, ChangeEvent, FormEvent, useRef, useEffect, ChangeEventHandler} from "react";
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  startUpload,
  uploadSuccess,
  uploadFailure,
} from "../../store/imageSlice";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config";
import axios from "axios";
import "rc-time-picker/assets/index.css";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import moment from "moment";
import { fetchUserData } from "../../store/UserSlice";
import { IHealthCondition } from "../../interfaces/HealthCondition";
import { RootState } from "../../store/store";

const ProgramBasics = ({ chnageTab, updateProgramId, updateStartDate, updateHasCounselling, programId }: any) => {

  const [title, setTitle] = useState("");
  const [date, setDate] = useState<Date|null>(moment().toDate());
  const [cost, setCost] = useState("");
  const [slot, setSlot] = useState("");

  const [participants, setParticipants] = useState("");
  const [zoom, setZoom] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState<string | null>(null);
  const [image, setImage] = useState<File | null>(null);
  const [healthCondition, setHealthCondition] = useState("");
  const [counsellingLink, setcounsellingLink] = useState("");
  const [hasCounselling, setHasCounselling] = useState(true);
  
  
  const [selectedImage, setSelectedImage] = useState<File | null>(null);

  const [errors, setError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImage(file);
    }
    // Validate file type
    if (file && file.type.includes("image")) {
      // Set the selected image for preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);

      // Set the selected image file
      setImage(file);
      setError(null);
    } else {
      // Handle invalid file type
      setSelectedImage(null);
      setImage(null);
      setError("Please upload a valid image file.");
    }
  };
  const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };
  const handleDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };
  const handleDateChange = (dateToChange: DateObject | DateObject[] | null) => {
    setDate(moment(dateToChange?.toString()).toDate());
  };
  const handleCostChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCost(e.target.value);
  };
  const handleslotChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSlot(e.target.value);
  };
  const handlepesChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParticipants(e.target.value);
  };
  const handlezoomChange = (e: ChangeEvent<HTMLInputElement>) => {
    setZoom(e.target.value);
  };

  const handlecounsellingLinkChange = (e: ChangeEvent<HTMLInputElement>) => {
    setcounsellingLink(e.target.value);
  };

  const handleHasCounsellingChange = (e: ChangeEvent<HTMLInputElement>) => {
    setHasCounselling(e.target.checked);
    if (updateHasCounselling) updateHasCounselling(e.target.checked);
  };

  const handleHealthCondition: ChangeEventHandler<HTMLSelectElement> = (e) => {
    setHealthCondition(e.target.value);
  };
  
  
  const dispatch = useDispatch()<any>;
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    // Dispatch startUpload action
    dispatch(startUpload());

    try {
      const formData = new FormData();
      if (selectedImage) {     
        formData.append("startDate", date?.toISOString() || "");
        formData.append("maxParticipants", participants);
        formData.append("totalCounsellings", slot);
        formData.append("zoomLink", zoom);
        formData.append("description", description);
        // formData.append('publish', 'true');
         formData.append("startTime", moment().toString());
         formData.append("endTime", moment().toString());
        formData.append("icon", selectedImage);
        formData.append("title", title);
        formData.append("cost", cost);
        formData.append("healthCondition", healthCondition);
        formData.append("counsellingLink", counsellingLink);
        formData.append("hasCounselling", String(hasCounselling));
        
      } else {
        // Handle the case where selectedImage is null
        // For example, show an error message or take appropriate action
        return;
      }
      const storedData = localStorage.getItem("loginData");
      if (!storedData) {
        // Handle the case where the stored data is null or undefined
        console.error("Stored data is null or undefined.");
        dispatch(uploadFailure("Stored data is null or undefined."));
        return;
      }

      const parsedData = JSON.parse(storedData);

      // Access the access token property
      const accessToken = parsedData?.accessToken;   
      if (accessToken) {
        const response = await axios.post(
          `${BASE_URL}/api/v1/programs`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${accessToken}`,
              // Add other headers if needed
            },
          }
        );

        // Dispatch uploadSuccess action
        dispatch(uploadSuccess(response.data.imageUrl));
        if (response.data.status) {
          updateProgramId(response.data.data.id)
          updateStartDate(response.data.data.startDate)
          
          localStorage.setItem('programId',response?.data?.data?.id);
          localStorage.setItem('startDate',response?.data?.data?.startDate);
          toast.info("Successfully Added");
          chnageTab(1);
        }
      } else {
        // Handle the case where the access token is not available
        // For example, show an error message or take appropriate action
        console.error("Access token is not available.");
        dispatch(uploadFailure("Access token is not available."));
      }
    } catch (error: any) {
      toast.error(error.response.data.error.message);
      // setError(error.response.data.error.message);
    }
  };

  useEffect(() => {
    const fetchProgramDetails = async () => {
      try {
        const storedData = localStorage.getItem("loginData");
        const id = programId ? programId : localStorage.getItem('programId');
        if (!storedData) {
          // Handle the case where the stored data is null or undefined
          console.error("Stored data is null or undefined.");
          // You might want to handle this case appropriately, e.g., redirect to login
          return;
        }

        const parsedData = JSON.parse(storedData);
        const accessToken = parsedData?.accessToken;

        if (!accessToken) {
          // Handle the case where the access token is not available
          console.error("Access token is not available.");
          // You might want to handle this case appropriately, e.g., redirect to login
          return;
        }

        const response = await axios.get(`${BASE_URL}/api/v1/programs/${id}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            // Add other headers if needed
          },
        });


        // Set the title with the fetched data
        const startDateString = response.data.data.startDate || "";
        const initialDate = startDateString ? new Date(startDateString) : null;
        
        setDate(initialDate);
        setTitle(response.data.data.title || ""); // Assuming the name field holds the title
        setImages(response.data.data.icon);
        setDescription(response.data.data.description || "");
        setCost(response.data.data.cost || "");
        setSlot(response.data.data.totalCounsellings || "");
        setParticipants(response.data.data.maxParticipants || "");
        setZoom(response.data.data.zoomLink || "");
        setHealthCondition(response.data.data.healthCondition || "");
        setcounsellingLink(response.data.data.counsellingLink || "");
        setHasCounselling(response.data.data.hasCounselling !== false);
        
        // setSelectedTime(moment(response.data.data.startTime).toDate());
      } catch (error) {
        console.error("Error fetching health condition details:", error);
      }
    };
    const newProgramId = programId ? programId : localStorage.getItem('programId')
    if (newProgramId) {
      fetchProgramDetails();
    }
  }, []);

  const { data, loading, error } = useSelector(
    (state: RootState) => state.user
  );
  

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

//  const parsedData = typeof data === "string" ? JSON.parse(data) : data;
  const parsedData:any =  useSelector(
    (state: RootState) => state.user.data
  );
  
  return (
    <div className="px-8 overflow-y-scroll max-h-[calc(100vh-220px)] scrollbar-hide pb-20">
      <form onSubmit={handleSubmit}>
        <div className=" mt-4 mb-4 ">
          <div className="flex items-center  w-full">
            <label
              className={`flex flex-col items-center  w-32 h-30 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 ${
                selectedImage instanceof File ? "hidden" : ""
              }`}
            >
              <div className="flex flex-col items-center justify-center pt-5 pb-6 ">
                <img
                  src="./images/gallery-add.png"
                  alt="upload"
                />
                <p className="text-xs text-[#4C535F] mt-4 font-gilroy">
                  Upload Icon
                </p>
              </div>
              <input
                id="image"
                type="file"
                name="image"
                onChange={handleImageChange}
                className={"visually-hidden"} // Corrected syntax
                accept="image/*"
                required = {!images}
                ref={fileInputRef}
              />
            </label>
            {selectedImage instanceof File && (
              <img
                src={URL.createObjectURL(selectedImage)}
                alt="preview"
                className="w-auto max-w-md pl-2 h-32 object-contain"
              />
            )}
            {images && (
                <img
                    src={images}
                    alt="preview"
                    className={`w-auto max-w-md pl-2 h-32 object-contain ${
                        selectedImage && "hidden"
                    } `}
                />
            )}

            {errors && <p style={{ color: "red" }}>{errors}</p>}
          </div>
        </div>
        <div className="flex flex-col md:flex-row">
        <div className="mb-4 w-full md:w-1/2  pr-4">
            <label
              className="block text-[#607D8B] text-sm  mb-2"
              htmlFor="title"
            >
              Title
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={title}
              onChange={handleTitleChange}
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
              placeholder="Please select your title"
              required
            />
          </div>
          <div className="mb-4 w-full md:w-1/2  pr-4">
            <label className="block text-[#607D8B] text-sm mb-2" htmlFor="date">
              Health Condition
            </label>
              <select  name="healthCondition" onChange={handleHealthCondition}  className="border-2 h-11 text-[#263238] bg-[#EDF2F6] placeholder:text-[#8D98AA] font-[18px] focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 focus:outline-none focus:border-gray-500 w-full">
                <option value="">Select Health Condition </option>
                {parsedData.healthConditions &&
                  parsedData.healthConditions.map(
              (healthCondition: IHealthCondition) => (       
                  <option key={healthCondition.id} value={healthCondition.id}>
                    {healthCondition.name}
                  </option>
                ))}
              </select>
          </div>
         
        </div>
        <div className="flex flex-col md:flex-row">
        <div className="mb-4 w-full md:w-1/2  pr-4">
            <label className="block text-[#607D8B] text-sm mb-2" htmlFor="date">
              Date
            </label>
            <DatePicker
              placeholder="mm/dd/yyyy"
              inputClass="border-2 text-[#263238] bg-[#EDF2F6] placeholder:text-[#8D98AA] font-[18px] focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 focus:outline-none focus:border-gray-500 w-full"
              containerClassName="w-full"
              calendarPosition="bottom"
              id={`date`}
              required
              highlightToday={true}
              onChange={(date) => handleDateChange(date)}
              format="MM/DD/YYYY"
              value={moment(date).format("MM/DD/YYYY")}
              minDate={new DateObject()}
            />
          </div>

          <div className="mb-4 w-full md:w-1/2  pr-4">
            <label
              className="block text-[#607D8B]  text-sm mb-2"
              htmlFor="title"
            >
              Cost
            </label>
            <input
              type="text"
              id="cost"
              name="cost"
              value={cost}
              onChange={handleCostChange}
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
              placeholder="Enter a Cost"
              required
            />
          </div>

          <div className="mb-4 w-full md:w-1/2  pr-4">
            <label
              className="block text-[#607D8B] text-sm mb-2"
              htmlFor="title"
            >
              Max participants
            </label>
            <input
              type="text"
              id="participants"
              name="participants"
              pattern="[0-9]*"
              value={participants}
              onChange={handlepesChange}
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
              placeholder="Enter a participants"
              required
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row mb-4">
          <div className="flex items-center w-full md:w-1/2 pr-4">
            <input
              type="checkbox"
              id="hasCounselling"
              name="hasCounselling"
              checked={hasCounselling}
              onChange={handleHasCounsellingChange}
              className="mr-2 h-4 w-4"
            />
            <label className="text-[#607D8B] text-sm" htmlFor="hasCounselling">
              Has 1-1 Counselling
            </label>
          </div>
        </div>

        {hasCounselling && (
          <div className="flex flex-col md:flex-row">
            <div className="mb-4 w-full md:w-1/2 pr-4">
              <label
                className="block text-[#607D8B] text-sm  mb-2"
                htmlFor="title"
              >
                Total Counsellings
              </label>
              <input
                type="text"
                id="slot"
                name="slot"
                value={slot}
                pattern="[0-9]*"
                onChange={handleslotChange}
                className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
                placeholder="Enter a total Counselling slots"
              />
            </div>
          </div>
        )}
        <div className="flex flex-col md:flex-col">
          <div className="mb-4 w-full  pr-4">
            <label
              className="block text-[#607D8B] text-sm  mb-2"
              htmlFor="title"
            >
              Zoom link
            </label>
            <input
              type="text"
              id="zoom"
              name="zoom"
              value={zoom}
              pattern="https?://.+"
              onChange={handlezoomChange}
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
              placeholder="Enter a zoom link"
              required
            />
          </div>
          {hasCounselling && (
          <div className="mb-4 w-full  pr-4">
            <label
              className="block text-[#607D8B] text-sm  mb-2"
              htmlFor="title"
            >
              Counselling 1-1 Meeting link
            </label>
            <input
              type="text"
              id="counsellingLink"
              name="counsellingLink"
              value={counsellingLink}
              pattern="https?://.+"
              onChange={handlecounsellingLinkChange}
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
              placeholder="Enter a Counselling 1-1 Meeting link"
            />
          </div>
          )}

          <div className="mb-4 w-full  pr-4">
            <label
              className="block text-[#607D8B] text-sm mb-2"
              htmlFor="title"
            >
              Description
            </label>

            <textarea
              id="description"
              name="description"
              onChange={handleDescriptionChange}
              className="resize-none border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
              rows={4}
              placeholder="Enter a description"
              value={description}
            ></textarea>
          </div>
        </div>

        <button
          type="submit"
          className="bg-[#B4804A] text-white font-semibold float-right w-32 py-2 px-4 mb-8 rounded-md"
        >
          Save
        </button>
        <Link
          to="/admin/programs"
          className="bg-[#90A4AE] text-white font-semibold float-right w-32 py-2 px-4 mb-8 mr-6 text-center rounded-md"
        >
          Cancel
        </Link>
      </form>
    </div>
  );
};

export default ProgramBasics;
